import * as yup from 'yup';

// only for the values field
export const IndicatorMDSSchema = yup.object({
  residentIdentifier: yup
    .string()
    .required('aqua_validation_required')
    .matches(/^[0-9]{6}$/, 'aqua_validation_residentIdentifier'),
  livingArea: yup
    .string()
    .required('aqua_validation_required')
    .matches(/^WB_([1-9]|[1-9][0-9])$/, 'aqua_validation_livingArea'),
  referenceDate: yup
    .string()
    .required('aqua_validation_required')
    .length(10, 'aqua_validation_date_format'),
  moveInDate: yup.string().when('reasonExclusion', {
    is: (reasonExclusion?: string) =>
      reasonExclusion === '1' || reasonExclusion === '3' || reasonExclusion === '4',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  birthMonth: yup
    .string()
    .oneOf(
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      'aqua_validation_birthMonth',
    )
    .required('aqua_validation_required'),
  birthYear: yup
    .string()
    .required('aqua_validation_required')
    .test('>= 1900 :valid', 'aqua_validation_birthYear', (value) =>
      value ? parseInt(value) >= 1900 && value.length === 4 : false,
    ),
  reasonExclusion: yup
    .string()
    .oneOf(['0', '1', '2', '3', '4', '5'], 'aqua_validation_0-5')
    .required('aqua_validation_required'),
});

export const IndicatorsSchema = yup.object({
  residentIdentifier: yup
    .string()
    .required('aqua_validation_required')
    .matches(/^[0-9]{6}$/, 'aqua_validation_residentIdentifier'),
  livingArea: yup
    .string()
    .required('aqua_validation_required')
    .matches(/^WB_([1-9]|[1-9][0-9])$/, 'aqua_validation_livingArea'),
  referenceDate: yup
    .string()
    .required('aqua_validation_required')
    .length(10, 'aqua_validation_date_format'),
  moveInDate: yup
    .string()
    .required('aqua_validation_required')
    .length(10, 'aqua_validation_date_format'),
  birthMonth: yup
    .string()
    .oneOf(
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      'aqua_validation_birthMonth',
    )
    .required('aqua_validation_required'),
  birthYear: yup
    .string()
    .required('aqua_validation_required')
    .test('>= 1900 :valid', 'aqua_validation_birthYear', (value) =>
      value ? parseInt(value) >= 1900 && value.length === 4 : false,
    ),
  careLevel: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  apoplex: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  apoplexDate: yup.string().when('apoplex', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  fracture: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  fractureDate: yup.string().when('fracture', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  heartAttack: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  heartAttackDate: yup.string().when('heartAttack', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  amputation: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  amputationDate: yup.string().when('amputation', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  hospitalTreatment: yup
    .string()
    .oneOf(['0', '1', '2'], 'aqua_validation_0-2')
    .required('aqua_validation_required'),
  hospitalTreatmentStartDate: yup.string().when('hospitalTreatment', {
    is: (hospitalTreatment?: string) => hospitalTreatment === '1' || hospitalTreatment === '2',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  hospitalTreatmentEndDate: yup.string().when('hospitalTreatment', {
    is: (hospitalTreatment?: string) => hospitalTreatment === '1' || hospitalTreatment === '2',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  consciousnessState: yup
    .string()
    .oneOf(['1', '2', '3', '4', '5'], 'aqua_validation_consciousnessState')
    .required('aqua_validation_required'),
  // TO DO: check "split"-case
  diagnosis: yup.string().min(1, 'aqua_validation_0-4').required('aqua_validation_required'),
  positionChangeBed: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  maintainSittingPosition: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  assumeDifferentSittingPosition: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  moveAroundLivingArea: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  climbStairs: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  recognizeClosePersons: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  localOrientation: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  temporalOrientation: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  remember: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  controlEverydayActions: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  makeEverydayDecisions: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  understandInformations: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  recognizeRisks: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  communicateNeeds: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  understandRequest: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  participateConversation: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  nutrition: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  externalAid: yup.string().when('nutrition', {
    is: '1',
    then: yup
      .string()
      .oneOf(['0', '1'], 'aqua_validation_0_or_1')
      .required('aqua_validation_required'),
  }),
  nutritionScope: yup.string().when('externalAid', {
    is: '1',
    then: yup.string().oneOf(['0', '6', '3']).required('aqua_validation_required'),
  }),
  bladderControl: yup
    .string()
    .oneOf(['0', '1', '2', '3', '4'], 'aqua_validation_0-4')
    .required('aqua_validation_required'),
  stoolControl: yup
    .string()
    .oneOf(['0', '1', '2', '3', '4'], 'aqua_validation_0-4')
    .required('aqua_validation_required'),
  washingUpperBodyFront: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  careHead: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  washingGenitalArea: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  showeringAndBathing: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  dressingUpperBody: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  dressingLowerBody: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  prepareBiteSize: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  eat: yup
    .string()
    .oneOf(['0', '3', '6', '9'], 'aqua_validation_eat')
    .required('aqua_validation_required'),
  drink: yup
    .string()
    .oneOf(['0', '2', '4', '6'], 'aqua_validation_drink')
    .required('aqua_validation_required'),
  usageToilet: yup
    .string()
    .oneOf(['0', '2', '4', '6'], 'aqua_validation_ usageToilet')
    .required('aqua_validation_required'),
  copingUrinaryIncontinence: yup.string().when('bladderControl', {
    is: (bladderControl?: string) =>
      bladderControl === '2' || bladderControl === '3' || bladderControl === '4',
    then: yup
      .string()
      .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
      .required('aqua_validation_required'),
  }),
  copingStoolIncontinence: yup.string().when('stoolControl', {
    is: (stoolControl?: string) =>
      stoolControl === '2' || stoolControl === '3' || stoolControl === '4',
    then: yup
      .string()
      .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
      .required('aqua_validation_required'),
  }),
  manageDailySchedule: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  rest: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  occupyOneself: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  planFutureActivities: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  interactWithPersons: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  humanRelations: yup
    .string()
    .oneOf(['0', '1', '2', '3'], 'aqua_validation_0-3')
    .required('aqua_validation_required'),
  decubitus: yup
    .string()
    .oneOf(['0', '1', '2'], 'aqua_validation_0-2')
    .required('aqua_validation_required'),
  decubitusStage: yup.string().when('decubitus', {
    is: (decubitus?: string) => decubitus === '1' || decubitus === '2',
    then: yup
      .string()
      .oneOf(['1', '2', '3', '4', '9'], 'aqua_validation_decubitusStage')
      .required('aqua_validation_required'),
  }),
  decubitus1StartDate: yup.string().when('decubitus', {
    is: '1',
    then: yup.string().when('decubitusStage', {
      is: (decubitusStage?: string) =>
        decubitusStage ? parseInt(decubitusStage) >= 2 && parseInt(decubitusStage) <= 9 : false,
      then: yup
        .string()
        .required('aqua_validation_required')
        .length(10, 'aqua_validation_date_format'),
    }),
  }),
  decubitus1EndDate: yup.string().when('decubitus', {
    is: '1',
    then: yup.string().when('decubitusStage', {
      is: (decubitusStage?: string) =>
        decubitusStage ? parseInt(decubitusStage) >= 2 && parseInt(decubitusStage) <= 9 : false,
      then: yup
        .string()
        .required('aqua_validation_required')
        .length(10, 'aqua_validation_date_format'),
    }),
  }),
  decubitus1Location: yup.string().when('decubitus', {
    is: '1',
    then: yup.string().when('decubitusStage', {
      is: (decubitusStage?: string) =>
        decubitusStage ? parseInt(decubitusStage) >= 2 && parseInt(decubitusStage) <= 9 : false,
      then: yup
        .string()
        .oneOf(['1', '2', '3', '4'], 'aqua_validation_1-4')
        .required('aqua_validation_required'),
    }),
  }),
  decubitus2StartDate: yup.string().when('decubitus', {
    is: '2',
    then: yup.string().when('decubitusStage', {
      is: (decubitusStage?: string) =>
        decubitusStage ? parseInt(decubitusStage) >= 2 && parseInt(decubitusStage) <= 9 : false,
      then: yup
        .string()
        .required('aqua_validation_required')
        .length(10, 'aqua_validation_date_format'),
    }),
  }),
  decubitus2EndDate: yup.string().when('decubitus', {
    is: '2',
    then: yup.string().when('decubitusStage', {
      is: (decubitusStage?: string) =>
        decubitusStage ? parseInt(decubitusStage) >= 2 && parseInt(decubitusStage) <= 9 : false,
      then: yup
        .string()
        .required('aqua_validation_required')
        .length(10, 'aqua_validation_date_format'),
    }),
  }),
  decubitus2Location: yup.string().when('decubitus', {
    is: '2',
    then: yup.string().when('decubitusStage', {
      is: (decubitusStage?: string) =>
        decubitusStage ? parseInt(decubitusStage) >= 2 && parseInt(decubitusStage) <= 9 : false,
      then: yup
        .string()
        .oneOf(['1', '2', '3', '4'], 'aqua_validation_1-4')
        .required('aqua_validation_required'),
    }),
  }),
  newMoveIn: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  moveInAfterShortTermCareStay: yup.string().when('newMoveIn', {
    is: '1',
    then: yup
      .string()
      .oneOf(['0', '1'], 'aqua_validation_0_or_1')
      .required('aqua_validation_required'),
  }),
  shortTermCareStayStart: yup.string().when('moveInAfterShortTermCareStay', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  bedSidePanel: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  belt: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  fall: yup
    .string()
    .required('aqua_validation_required')
    .oneOf(['0', '1', '2'], 'aqua_validation_0-2'),
  // TO DO: check "split"-case
  fallConsequences: yup.string().when('fall', {
    is: (fallConsequences?: string) => fallConsequences === '1' || fallConsequences === '2',
    then: yup.string().min(1, 'aqua_validation_0-4').required('aqua_validation_required'),
  }),
  hospitalizationAfterMoveIn: yup.string().when('newMoveIn', {
    is: '1',
    then: yup
      .string()
      .oneOf(['0', '1'], 'aqua_validation_0_or_1')
      .required('aqua_validation_required'),
  }),
  hospitalizationAfterMoveInEnd: yup.string().when('hospitalizationAfterMoveIn', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  hospitalizationAfterMoveInStart: yup.string().when('hospitalizationAfterMoveIn', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  integrationTalk: yup.string().when('newMoveIn', {
    is: '1',
    then: yup
      .string()
      .oneOf(['1', '2', '3'], 'aqua_validation_1-3')
      .required('aqua_validation_required'),
  }),
  integrationTalkDate: yup.string().when('integrationTalk', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  integrationTalkDocumentation: yup.string().when('integrationTalk', {
    is: '1',
    then: yup
      .string()
      .oneOf(['0', '1'], 'aqua_validation_0_or_1')
      .required('aqua_validation_required'),
  }),
  // // TO DO: check "split"-case
  integrationTalkParticipants: yup.string().when('integrationTalk', {
    is: '1',
    then: yup.string().min(1, 'aqua_validation_0-4').required('aqua_validation_required'),
  }),
  pain: yup
    .string()
    .oneOf(['0', '1'], 'aqua_validation_0_or_1')
    .required('aqua_validation_required'),
  // TO DO: check "split"-case
  painAssessment: yup.string().when('painFree', {
    is: '0',
    then: yup.string().min(1, 'aqua_validation_0_or_1').required('aqua_validation_required'),
  }),
  painAssessmentDate: yup.string().when('painAssessment', {
    is: '1',
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
  painAssessmentInfo: yup.string().when('painAssessment', {
    is: '1',
    // TO DO: check "split"-case
    then: yup.string().min(1, 'aqua_validation_0-4').required('aqua_validation_required'),
  }),
  painFree: yup.string().when('pain', {
    is: '1',
    then: yup
      .string()
      .oneOf(['0', '1'], 'aqua_validation_0_or_1')
      .required('aqua_validation_required'),
  }),
  // TO DO: check "split"-case
  weightDocumentation: yup
    .string()
    .min(1, 'aqua_validation_0-5')
    .required('aqua_validation_required'),
  weight: yup.string().when('weightDocumentation', {
    is: (weightDocumentation?: string) =>
      weightDocumentation
        ? parseInt(weightDocumentation) >= 0 && parseInt(weightDocumentation) <= 3
        : false,
    then: yup
      .string()
      .required('aqua_validation_required')
      .test('is <=500 and >=0 :valid', 'aqua_validation_weight', (value) =>
        value ? parseInt(value) <= 500 && parseInt(value) >= 0 : false,
      ),
  }),
  weightDate: yup.string().when('weight', {
    is: (weight?: string) => (weight ? true : false),
    then: yup
      .string()
      .required('aqua_validation_required')
      .length(10, 'aqua_validation_date_format'),
  }),
});
